import { apiUrl, mainWeb, mainWebResource } from '../../config/net'
const baseUrl = `${mainWeb}${mainWebResource}`
const index = `${apiUrl}/v0/onlinemall/profile`
const integralInfo = 'getmyintegralinfo'
const integralInfoDetail = 'getintegralloglist'
const orderList = 'getorderlist'

export default {
  index,
  baseUrl,
  integralInfo,
  integralInfoDetail,
  orderList
}



// WEBPACK FOOTER //
// ./src/model/about-user/resource-url.js